/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ShapeCircleMDashIcon16Light } from './ShapeCircleMDashIcon16Light';
import { ShapeCircleMDashIcon16Regular } from './ShapeCircleMDashIcon16Regular';
import { ShapeCircleMDashIcon16Solid } from './ShapeCircleMDashIcon16Solid';
import { ShapeCircleMDashIcon20Light } from './ShapeCircleMDashIcon20Light';
import { ShapeCircleMDashIcon20Regular } from './ShapeCircleMDashIcon20Regular';
import { ShapeCircleMDashIcon20Solid } from './ShapeCircleMDashIcon20Solid';
import { ShapeCircleMDashIcon24Regular } from './ShapeCircleMDashIcon24Regular';
import { ShapeCircleMDashIcon24Solid } from './ShapeCircleMDashIcon24Solid';
import { ShapeCircleMDashIcon32Regular } from './ShapeCircleMDashIcon32Regular';
import { ShapeCircleMDashIcon64Regular } from './ShapeCircleMDashIcon64Regular';
var sizes = {
    16: {
        light: ShapeCircleMDashIcon16Light,
        regular: ShapeCircleMDashIcon16Regular,
        solid: ShapeCircleMDashIcon16Solid,
    },
    20: {
        light: ShapeCircleMDashIcon20Light,
        regular: ShapeCircleMDashIcon20Regular,
        solid: ShapeCircleMDashIcon20Solid,
    },
    24: {
        regular: ShapeCircleMDashIcon24Regular,
        solid: ShapeCircleMDashIcon24Solid,
    },
    32: {
        regular: ShapeCircleMDashIcon32Regular,
    },
    64: {
        regular: ShapeCircleMDashIcon64Regular,
    },
};
export var ShapeCircleMDashIcon = forwardRef('ShapeCircleMDashIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
